import { render } from "./BannerSlider.vue?vue&type=template&id=6b00de50&scoped=true"
import script from "./BannerSlider.vue?vue&type=script&lang=js"
export * from "./BannerSlider.vue?vue&type=script&lang=js"

import "./BannerSlider.vue?vue&type=style&index=0&id=6b00de50&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b00de50"]])

export default __exports__